<template>
  <div class="card modal-card">
    <div class="modal-card-body pd-0">
      <header class="bandeau-modal card-header">
      </header>
      <div class="card-content">
        <div class="columns is-gapless center">
          <div class="column mgt-20px">
            <h1 class="title is-size-3">
              {{ $t(title) }}
            </h1>
          </div>
        </div>
        <div v-if="libelleList.length" class="mgb-10px">
          <app-information-msg-component
            :libelleList="libelleList">
          </app-information-msg-component>
        </div>
        <error-msg-component
          :messages="error.messages"
          :error="error.haveError"
          :messagesChampsVide="error.messagesChampsVide"
          :champsVide="error.champsVide"
          @close="error.haveError = $event"
          title="general.problemOccurred"
          withEmplyFields/>
        <div class="columns mgt-20px">
          <div class="column is-6">
            <b-field :label="$t('addSecteurLien.addPopUp.secteurTypes')">
              <b-select
                v-model="selectedSecteurType"
                :disabled="!!secteurType"
                expanded>
                <option :value="null"></option>
                <option
                  v-for="secteurType in constants.SECTEUR_TYPE"
                  :key="secteurType.code"
                  :value="secteurType.code">
                  {{$t(secteurType.libelle)}}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <secteur-select
              v-model="selectedSelecteur"
              :label="$t('addSecteurLien.addPopUp.secteur')"
              :type="selectedSecteurType"
              obligatoire
            />
          </div>
        </div>
        <footer class="pdt-20px">
          <b-field>
            <div class="is-pulled-left boutonAction">
              <a class="button" @click="$parent.close">
                {{ $t('general.button.cancel')}}
              </a>
            </div>
            <div class="is-pulled-left boutonAction">
              <a class="button is-addOrEdit" @click="actionValider">
                {{ $t('general.button.valider')}}
              </a>
            </div>
          </b-field>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { SECTEUR_TYPE } from '@/configuration/parametrage/secteurConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import secteurSelect from '@/components/commun/secteur/secteurSelect';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import validationGeneral from '@/services/validation/validation';
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';

export default {
  props: {
    secteurType: {
      type: String,
      default: null,
      required: false,
    },
    itemsIds: {
      type: Array,
      required: true,
    },
    actionSecteur: {
      type: Function,
      required: true,
    },
    isAdd: {
      type: Boolean,
      required: true,
    },
    translator: {
      type: Function,
      required: true,
    },
    validation: {
      type: Function,
      required: false,
    },
    libelleList: {
      type: Array,
      required: false,
      default: () => ([]),
    },
    refresh: {
      type: Function,
      required: false,
    },
  },
  components: {
    errorMsgComponent,
    secteurSelect,
    AppInformationMsgComponent,
  },
  data() {
    return {
      selectedSecteurType: null,
      selectedSelecteur: null,
      constants: {
        SECTEUR_TYPE,
      },
      error: {
        haveError: false,
        messages: [],
        champsVide: [],
        messagesChampsVide: [],
      },
    };
  },
  computed: {
    title() {
      return this.isAdd
        ? 'addSecteurLien.addPopUp.titleAddSecteurForElements'
        : 'addSecteurLien.addPopUp.titleDeleteSecteurForElements';
    },
    msgSuccess() {
      return this.isAdd
        ? 'addSecteurLien.success.secteurIsAddOnElementsSelected'
        : 'addSecteurLien.success.secteurIsDeleteOnElementsSelected';
    },
  },
  methods: {
    async actionValider() {
      this.error.haveError = false;
      this.error.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.actionSecteur({
          itemIds: this.itemsIds,
          secteurId: this.selectedSelecteur,
        });
        this.refresh();
        messageSucces(this.$i18n.t(this.msgSuccess));
        this.$emit('close');
      } catch (e) {
        this.error.haveError = true;
        if (e.response?.data?.error) {
          validationGeneral(this.$i18n, e.response, this.error.champsVide,
            this.error.messages, this.error.messagesChampsVide,
            this.translator);
          if (this.validation) {
            this.validation(e.response, this.error.messages);
          }
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  mounted() {
    this.selectedSecteurType = this.secteurType;
  },
};
</script>
